export default "__VITE_ASSET__DOm7dIgF__"